/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/*eslint-disable */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CardHeader.css';

const hiddeCardHeader = (turnos) => {
  let contShow = 0
  turnos.forEach(element => {
    if(element.horarios.length === 0){
      contShow--
    }else{
      contShow++
    }
  });
  return (contShow < 0) ? true : false
}


const CardHeader = (props) => {
  //if(hiddeCardHeader(props.turnosPorfecha.turnos)){
  //  return(<div></div>)
  //}
  return (
    <div className={`${s.backColor} card col-md-12 text-center`}>
      <div className={`${s.header_card} ${s.backColor} card-header text-center`}>
        
            {`Profesionales Disponibles el ${props.fechaCard}`}
        </div>
      </div>
  );
}
export default (withStyles(s)(CardHeader));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/CardHeader/CardHeader.js